import axios from 'axios'
import router from '@/router/index'
import { Spin } from 'iview'
import store from '@/store'
import DomMessage from './messageOnce'
import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import mixCommon from '@/common/mixCommon.js'
import { encodeURL } from 'js-base64'
import { renewalLogin } from '@/api/auth.js'
import { Modal } from 'view-design'
import Cookies from 'js-cookie'
import i18n from '@/locale/index' 

const messageOnce = new DomMessage()
let onOff = false
let riskCheck = true
//服务器的公钥
let serverPubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCh5QRBjoUOOwcdSAuHup8GuC19szzV7MY9skA2riqMZOWYa9Mj59Utl6SG9ZM1sJJLtAzMMDJIuRCZrka0KYlH_CP1WfyZC9jbhurL7Vzg6-BFI865CKvGkgr8p6TCaKoPOSLy9s1IRzhsSebFBNcKep97lHQGXswzpfDmJtpXfQIDAQAB'

let aesKeyF
var aesKey
if (onOff) {
  var iv = CryptoJS.lib.WordArray.random(16)
  if (window.sessionStorage.getItem('aesKey')) {
    aesKeyF = window.sessionStorage.getItem('aesKey')
  } else {
    aesKeyF = CryptoJS.lib.WordArray.random(16)
    aesKeyF = CryptoJS.enc.Base64.stringify(aesKeyF)
    window.sessionStorage.setItem('aesKey', aesKeyF)
  }
}

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        // add custom headers if needed
      }
    }
    return config
  }

  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      Spin.hide()
    }
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      const allCookies = document.cookie.split('; ').reduce((acc, cookie) => {
        const [name, value] = cookie.split('=')
        acc[name.trim()] = value.trim()
        return acc
      }, {})
      // console.log('所有cookie及其值:', allCookies);
      // console.log('请求配置中的 withCredentials:', config.withCredentials);
      // console.log('请求头中的 Cookie:', config.headers.Cookie);
      // 获取存储在 cookie 中的 LevelA - LevelE 和 company/project
      const levelA = Cookies.get('levelA')
      const levelB = Cookies.get('levelB')
      const levelC = Cookies.get('levelC')
      const levelD = Cookies.get('levelD')
      const levelE = Cookies.get('levelE')
      const company = Cookies.get('company') // 获取 company (LevelA)
      const project = Cookies.get('project') // 获取 project (LevelC)
      const safeTableName = Cookies.get('safeTableName') // 获取 safeTableName

      // 将这些层级信息添加到请求头中
      if (levelA && levelB && levelC && levelD && levelE) {
        config.headers['Level-A'] = levelA
        config.headers['Level-B'] = levelB
        config.headers['Level-C'] = levelC
        config.headers['Level-D'] = levelD
        config.headers['Level-E'] = levelE
      }

      // 如果 company 和 project 存在，将其添加到请求头
      if (company) {
        config.headers['company'] = company
      }
      if (project) {
        config.headers['project'] = project
      }
      // 如果 safeTableName 存在，将其添加到请求头
      if (safeTableName) {
        config.headers['safeTableName'] = safeTableName
      }

      mixCommon.setKey(onOff, serverPubKey)

      if (sessionStorage.getItem('token')) {
        config.headers['accesstoken'] = sessionStorage.getItem('token')
      }

      if (sessionStorage.getItem('uInfo') && url.startsWith('/newapi')) {
        config.headers['uinfo'] = encodeURI(sessionStorage.getItem('uInfo'))
      }

      let comP = isPamars(config)
      config.url = config.url + comP

      if (!config.data) {
        config.data = {}
      }
      if (riskCheck) {
        config.headers['x-front-type'] = 'pc'
      }

      config.headers['Lang'] = (localStorage.getItem('LANG_STORAGE') || 'zh-CN').replace(/-/g, '_')

      if (!config.headers.noEncryption) {
        if (onOff) {
          aesKey = window.sessionStorage.getItem('aesKey') || aesKeyF
          var rsaCrypt = new JSEncrypt()
          rsaCrypt.setPublicKey(serverPubKey)
          var cipherAesKey = rsaCrypt.encrypt(aesKey)

          let cipherData = CryptoJS.AES.encrypt(JSON.stringify(config.data),
            CryptoJS.enc.Base64.parse(aesKey),
            {
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
            })
          config.headers['x-cipher-iv'] = CryptoJS.enc.Base64.stringify(iv)
          if (config.headers.isLogin) {
            config.headers['x-cipher-key'] = cipherAesKey
          }
          config.headers.post['Content-Type'] = 'application/json'
          config.data = cipherData.toString()
        }
      }

      if (!Object.keys(this.queue).length && !config.data.hasOwnProperty('isLoading') && config.data.loadingOff) {
        Spin.show({
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                  type: 'ios-loading',
                  size: 35
                }
              }),
              h('div', 'Loading')
            ])
          }
        })
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })

    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      // console.log(res,'dddd');

      let { data, status, headers, config } = res

      if (headers && headers.accesstoken) {
        store.commit('set_token', headers.accesstoken)
      }

      if (Object.prototype.toString.call(data) === '[object Object]' && data.code !== 0) {
        // Message.error(data.msg)
        // messageOnce.error((data.msg || '').replace(/\n/g, '<br/>'))
      }

      // Token失效，弹出提示框，提供续期按钮
      if (data.code == 401) { // 如果code为4，代表token过期
        Modal.confirm({
          title: 'Login expiration reminder',
          content: '<p>Your login information has expired, please log in again</p>',
          okText: 'OK',
          cancelText: 'Cancel',
          onOk: () => {
            // 点击取消按钮时，跳转到登录页面
            store.commit('del_uInfo')
            store.commit('del_token')
            setTimeout(() => {
              router.push({ name: 'login' })
            }, 800)
            // renewalLogin().then((res) => {
            //   if (res.data.code === 200) {

            //     // 重新发起原请求
            //     instance(config)
            //   } else {
            //     this.$notice.error(this.$t("续期失败，请重新登录！"));
            //     setTimeout(() => {
            //       store.commit('del_uInfo')
            //       store.commit('del_token')
            //       router.push({ name: 'login' })
            //     }, 800)
            //   }

            // });
          },
          onCancel: () => {
            // 点击取消按钮时，跳转到登录页面
            store.commit('del_uInfo')
            store.commit('del_token')
            setTimeout(() => {
              router.push({ name: 'login' })
            }, 800)
          }
        })

        // MessageBox.confirm('您的登录信息已过期，是否续期？', 'Token过期', {
        //   confirmButtonText: '续期',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   // 点击续期按钮，调用 /auth-center/refresh-token 接口
        //   axios.post('/auth-center/refresh-token', {}, {
        //     headers: {
        //       'accesstoken': sessionStorage.getItem('token')
        //     }
        //   }).then(response => {
        //     if (response.data.code === 0) {
        //       // 续期成功，更新 token，并重新发起原请求
        //       store.commit('set_token', response.data.data.token)
        //       sessionStorage.setItem('token', response.data.data.token)

        //       // 重新发起原请求
        //       instance(config)
        //     } else {
        //       Message.error('续期失败，请重新登录！')
        //       setTimeout(() => {
        //         store.commit('del_uInfo')
        //         store.commit('del_token')
        //         router.push({ name: 'login' })
        //       }, 800)
        //     }
        //   }).catch(error => {
        //     Message.error('续期请求失败，请重试！')
        //     console.error(error)
        //   })
        // }).catch(() => {
        //   // 点击取消按钮时，跳转到登录页面
        //   store.commit('del_uInfo')
        //   store.commit('del_token')
        //   setTimeout(() => {
        //     router.push({ name: 'login' })
        //   }, 800)
        // })
      }

      if (onOff) {
        if (!res.config.headers.noEncryption && res.headers['content-type'].indexOf('application/json') == 0) {
          if (!data.data) {
            let seeData = CryptoJS.AES.decrypt(data,
              CryptoJS.enc.Base64.parse(aesKey),
              {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
              })
            data = JSON.parse(seeData.toString(CryptoJS.enc.Utf8))
          }
        }
      }
      return { data, status, headers }
    }, error => {
      this.destroy(url)
      // 错误处理
      let errorInfo = error.response
      return Promise.reject(error)
    })
  }

  request(options) {
    const instance = axios.create({
      timeout: 1000 * 60 * 2,
      withCredentials: true
    })
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}

let isPamars = (params) => {
  let lengths = 0
  for (const key in params.data) {
    if (isObject(params.data[key])) { // 值不能为对象
      lengths = 2
    }
    lengths++
  }
  let parmarsData = params.data
  let comP = ''
  let keyIndex = 1
  if (lengths == 1) {
    if (params.url.substr(params.url.length - 1, 1) == '?') {
      for (let key in parmarsData) {
        comP += `&${key}=${parmarsData[key]}`
      }
    } else {
      for (let key in parmarsData) {
        if (keyIndex == 1) {
          comP += `?${key}=${parmarsData[key]}`
        } else {
          comP += `&${key}=${parmarsData[key]}`
        }
        keyIndex++
      }
    }
  }
  return comP
}

const isObject = (obj) => {
  if (obj && obj instanceof Object) {
    return true
  } else {
    return false
  }
}

export default HttpRequest
